/* eslint-disable react/display-name */
/**
 * @file rolesManagementView.jsx
 * @author Fernando Ruano
 * @description Roles Management View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Helpers
import { sortString } from '@nephro/commons/helpers/utils';

// Components
import ManagementCrud from '@nephro/components/ManagementCrud';

/**
 * Roles Management View
 * @param { Object } roleActions - Role Actions.
 * @return { Node } React node.
 */
function RolesManagementView({ roleActions }) {
  const { t: translate } = useTranslation();
  const { getRolesArray, deleteRoleById } = roleActions;

  // Table columns
  const columns = [
    {
      title: translate('commons.name'),
      dataIndex: 'name',
      sorter: sortString('name')
    },
    {
      title: translate('commons.description'),
      dataIndex: 'description',
      sorter: sortString('description')
    }
  ];

  return (
    <div className="h-full">
      <AppCardLayout>
        <ManagementCrud
          viewEyeIcon={false}
          getItemsArray={getRolesArray}
          deleteItemById={deleteRoleById}
          columns={columns}
          deleteConfirmText={'roleMg.deleteRole'}
          createButtonText={'roleMg.create'}
          itemIdKey={'role_id'}
        />
      </AppCardLayout>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
RolesManagementView.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired,
  roleActions: PropTypes.shape({
    getRolesArray: PropTypes.func.isRequired,
    deleteRoleById: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  loading: PropTypes.bool,
  history: PropTypes.any
};

export default RolesManagementView;
